// 빈 상태 안내 (X1) — 데이터가 없을 때만 그리는 설명 블록. 데이터가 들어오면 화면은 종전 그대로다.
//   UploadGuide     문서 업로드 드롭존 아래 '자동 분류 서류 + 처리 방식' 2열 카드
//   StepStrip       번호 + 단계명 + 설명 칸 스트립 (말소 진행 4단계 · 보강서류 3단계 공용)
// 새 API·새 데이터 없음 — 서버가 이미 하는 일(utils/ocrPrompts.js 의 분류 5종, cancelRider 단계)을 문장으로 옮긴 것.
import React from 'react';
import { T, R, FONT } from '../../theme';
import { Card, Sec } from '../../kit';

// 자동 분류 서류 — 서버 OCR_PROMPT_SMART_UPLOAD 의 분류 5종 (그 밖은 '기타'로 미분류 보관)
var AUTO_DOCS = [
  { name: '말소증', desc: '말소등록사실증명서 — 차량번호·차대번호로 매칭' },
  { name: '수출면장', desc: '수출신고필증 — 신고번호 + 차대번호 여러 대 한 번에' },
  { name: '구매확인서', desc: '차대번호 여러 대 한 번에' },
  { name: '세금계산서', desc: '차량번호 + 차대번호 뒷자리' },
  { name: '자동차등록증', desc: '차량번호·차대번호' }
];
var HOW = [
  '파일을 올리면 문서 종류를 먼저 판별합니다.',
  '문서에서 읽은 차량번호·차대번호로 재고 차량을 찾습니다.',
  '찾으면 그 차량 서류함에 저장하고, 말소증·수출면장은 진행 단계까지 올립니다.',
  '못 찾으면 미분류로 보관하고 결과 표에 사유를 적습니다.'
];

var grid2 = { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 24, padding: '4px 14px 6px' };
var grid1 = { display: 'grid', gridTemplateColumns: '1fr', gap: 6, padding: '4px 14px 6px' };
var docRow = { display: 'flex', gap: 10, alignItems: 'baseline', padding: '5px 0', borderBottom: '1px solid ' + T.bdSoft, fontSize: FONT.body, color: T.body };
var docName = { flex: '0 0 92px', fontWeight: 700, color: T.ink };
var docDesc = { flex: 1, color: T.muted };
var howRow = { display: 'flex', gap: 8, alignItems: 'flex-start', padding: '5px 0', fontSize: FONT.body, color: T.body, lineHeight: 1.5 };
var no = {
  flex: '0 0 18px', width: 18, height: 18, borderRadius: R.pill, background: T.accentTint, border: '1px solid ' + T.accentBd,
  color: T.accentPress, fontSize: FONT.badge, fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
};
var hint = { fontSize: FONT.label, color: T.faint, marginTop: 8, lineHeight: 1.6 };
var note = { padding: '10px 14px 14px', fontSize: FONT.label, color: T.faint, lineHeight: 1.6, borderTop: '1px solid ' + T.bdSoft, marginTop: 8 };

// ── 단계 스트립 (말소 진행 4 · 보강서류 3) ──
var cell = { border: '1px solid ' + T.bd, borderRadius: R.md, background: T.head, padding: '10px 12px' };
var cellHead = { display: 'flex', gap: 8, alignItems: 'center', fontSize: FONT.body, fontWeight: 800, color: T.ink };
var cellDesc = { fontSize: FONT.label, color: T.muted, lineHeight: 1.6, marginTop: 6 };
var stripWrap = { padding: '0 14px 16px' };

// props: label, steps:[{name, desc}], isMobile
export function StepStrip(props) {
  var steps = props.steps || [];
  var cols = props.isMobile ? '1fr' : 'repeat(' + steps.length + ', minmax(0,1fr))';
  return (<div style={stripWrap}>
    <Sec label={props.label} />
    <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 10 }}>
      {steps.map(function (s, i) {
        return (<div key={s.name} style={cell}>
          <div style={cellHead}><span style={no}>{i + 1}</span><span>{s.name}</span></div>
          <div style={cellDesc}>{s.desc}</div>
        </div>);
      })}
    </div>
  </div>);
}

// props: isMobile
export function UploadGuide(props) {
  return (<Card title="지원 서류와 자동 분류 방식" style={{ marginTop: 14 }}>
    <div style={props.isMobile ? grid1 : grid2}>
      <div>
        <Sec label="자동 분류 서류" right={AUTO_DOCS.length + '종'} />
        {AUTO_DOCS.map(function (d) {
          return (<div key={d.name} style={docRow}><span style={docName}>{d.name}</span><span style={docDesc}>{d.desc}</span></div>);
        })}
      </div>
      <div>
        <Sec label="처리 방식" />
        {HOW.map(function (t, i) {
          return (<div key={t} style={howRow}><span style={no}>{i + 1}</span><span>{t}</span></div>);
        })}
        <div style={hint}>한 번에 3건씩 동시 처리 · 파일당 최대 50MB · 이미지는 업로드 전 자동 압축</div>
      </div>
    </div>
    <div style={note}>매매계약서 · 말소신청서 · 비사업용확인서 · 품의서 · 입금증 · 현장계약서는 자동 분류 대상이 아닙니다 — 차량 목록에서 차량을 열어 서류 탭에서 등록하세요.</div>
  </Card>);
}

// 말소 진행 빈 상태 — 4단계 흐름 (CancelTrackingScreen STEPS 와 같은 순서)
export var CANCEL_STEPS = [
  { name: '접수대기', desc: '신청이 말소대행업체로 전달되고 담당자 배정을 기다립니다.' },
  { name: '담당배정', desc: '담당자가 배정되어 번호판 수거 일정을 잡습니다.' },
  { name: '번호판 수거완료', desc: '번호판을 수거해 말소 등록을 진행합니다.' },
  { name: '말소완료', desc: '말소증이 등록되고 차량이 말소완료 단계로 넘어갑니다.' }
];
// 보강서류 빈 상태 — 제출 흐름 3단계
export var DOC_STEPS = [
  { name: '요청 도착', desc: '대행업체가 필요한 서류를 지정하면 알림과 함께 이 목록에 쌓입니다.' },
  { name: '서류 제출', desc: '건을 열어 서류 제출로 파일을 올리면 대행업체로 바로 전달됩니다.' },
  { name: '확인 완료', desc: '대행업체가 확인하면 완료로 바뀌고 말소 진행이 이어집니다.' }
];

// 보강서류 빈 상태 머리말 — EmptyState 문구 아래 1줄
var lead = { padding: '0 26px 12px', textAlign: 'center', color: T.faint, fontSize: FONT.body };
export function CancelDocLead() {
  return <div style={lead}>대행업체가 요청하면 여기에 쌓입니다.</div>;
}
